import {HttpCrudDataSource} from '../../../core/data-source/http-crud.data-source';
import {httpService} from '../../../core/services/http.service';

export class FuelCostReportCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/reports/loadReport';

    async load(): Promise<any> {
        return httpService
            .get(this.apiPath, {transformResponse: (data: any) => new Function(' return ' + data)()})
            .then((response) => response.data.rows);
    }

    exportReport(fileName: string): Window {
        const url: string =
            httpService.getBaseUrl() +
            '/gt/gt-api/reports/loadReport/' +
            Date.now() +
            '/?type=Excel&fileName=' +
            fileName;
        const result: Window = window.open(url, '_blank');
        return result;
    }
}
